import { Link } from 'react-router-dom'
import { IconArrowRight } from '../ui/Icon'
import { SERVICE_ROUTES } from '../../data/services'

/**
 * The other two services as the page's closing pair: two large typographic
 * links side by side on one heavy rule, split by a hairline — each the
 * service's name with its arrow, the page's one-line description and two
 * feature legends. No frames, no pictograms: the names carry it.
 *
 * @param {{
 *   lang: 'tr' | 'en' | 'de',
 *   title: string,
 *   items: Array<{ service: 'pad' | 'screen' | 'assembly', name: string, desc: string, features: string[] }>,
 * }} props
 */
export default function RelatedServices({ lang, title, items }) {
  return (
    <section className="sp-related" aria-labelledby="sp-related-title">
      <div className="container">
        <h2 className="sp-minor-title" id="sp-related-title">
          {title}
        </h2>
        <ul className="sp-related-list" role="list">
          {items.map((item) => (
            <li key={item.service}>
              <Link
                to={SERVICE_ROUTES[item.service][lang]}
                className="sp-related-link"
                aria-labelledby={`sp-related-${item.service}-name`}
                aria-describedby={`sp-related-${item.service}-desc`}
                viewTransition
              >
                <span className="sp-related-name">
                  <span id={`sp-related-${item.service}-name`}>{item.name}</span>
                  <IconArrowRight className="sp-related-arrow" size={28} />
                </span>
                <span className="sp-related-desc" id={`sp-related-${item.service}-desc`}>
                  {item.desc}
                </span>
                <span className="sp-related-features">
                  {item.features.map((feature) => (
                    <span className="legend" key={feature}>
                      {feature}
                    </span>
                  ))}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
